export const theme = {
    color: {
        silver: "#ccc",
        alto: "#ddd",
        bondiBlue: "#00B3B3",
        teal: "#008080",
        forestGreen: "#218c21",
    },
    breakpoint: {
    mobileMax:767,
    },
};